import { useState } from "react";
import { upload, GifUploaderError } from "utils/gifUploader";
import { ImageUploader } from "./ImageUploader";

interface IImageUploaderContainerProps {
  preview?: string;
  title: string;
  onReady: (ticketId: string) => void;
  onError: (error: string) => void;
  onProgress: (percent: number) => void;
}

export const ImageUploaderContainer: React.FC<IImageUploaderContainerProps> = (props) => {
  const { preview, title, onReady, onError, onProgress } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [isError, setError] = useState(false);

  const onFileUpload = async (file: File) => {
    try {
      setLoading(true);
      setError(false);
      const { id } = await upload(
        file,
        (sent: { percent: number }) => onProgress(sent.percent)
      );

      onReady(id);
      onProgress(0);
    } catch (err) {
      const error = err as GifUploaderError;
      onError(error.message);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ImageUploader
      preview={preview}
      isError={isError}
      loading={loading}
      title={title}
      onFileUpload={onFileUpload}
    />
  );
};
